import React, { useState, useEffect } from 'react';

const REASONS = [
  "I don't use it anymore",
  "Too many notifications",
  "Missing features I need",
  "Switched to a different app",
  "Privacy concerns",
  "Other reason"
];

const STEP_LABELS = ['Warning', 'Reason', 'Confirm', 'Done'];

const DeleteAccount = ({ navigateTo }) => {
  const [step, setStep] = useState(1);
  const [reason, setReason] = useState('');
  const [confirmInput, setConfirmInput] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleDelete = () => {
    setIsDeleting(true);
    setTimeout(() => { setStep(4); setIsDeleting(false); }, 1800);
  };

  const stepperDot = (i) => {
    const num = i + 1;
    let cls = 'del-step-dot';
    if (num < step) cls += ' done active';
    else if (num === step) cls += ' current';
    return (
      <div className={cls} key={num}>
        <div className="del-step-circle">{num < step ? '✓' : num}</div>
        <span className="del-step-lbl">{STEP_LABELS[i]}</span>
      </div>
    );
  };

  return (
    <div className="del-page">
      <div className="del-card">
        <div className="del-stepper">
          {[0, 1, 2, 3].map(stepperDot)}
        </div>

        {step === 1 && (
          <div className="step-fade-in" key="s1">
            <p style={{fontSize:'.65rem',fontWeight:800,letterSpacing:'.1em',textTransform:'uppercase',color:'var(--text-2)',marginBottom:8,fontFamily:"'Space Mono',monospace"}}>Step 1 of 4</p>
            <div className="del-h2">⚠️ Wait — are you sure?</div>
            <div className="del-sub">Deleting your account is permanent and cannot be undone. Here's what you'll lose:</div>
            <div className="del-warn-box">
              <ul>
                <li>Access to your full transaction history and receipts</li>
                <li>All saved payment methods and bank accounts</li>
                <li>Any pending rewards, cashback, or referral credits</li>
                <li>Your unique SequPay ID and username</li>
                <li>All KYC data stored securely on our servers</li>
              </ul>
            </div>
            <div className="del-btn-row">
              <button className="btn-ghost" onClick={() => navigateTo('home')}>Keep my account</button>
              <button className="btn-solid-danger" onClick={() => setStep(2)}>I understand, continue</button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="step-fade-in" key="s2">
            <p style={{fontSize:'.65rem',fontWeight:800,letterSpacing:'.1em',textTransform:'uppercase',color:'var(--text-2)',marginBottom:8,fontFamily:"'Space Mono',monospace"}}>Step 2 of 4</p>
            <div className="del-h2">Why are you leaving?</div>
            <div className="del-sub">Your feedback helps us improve SequPay for everyone.</div>
            <div className="del-radio-group">
              {REASONS.map(r => (
                <label key={r} className={`del-radio ${reason === r ? 'sel' : ''}`} onClick={() => setReason(r)}>
                  <input type="radio" name="reason" value={r} readOnly checked={reason === r} />
                  {r}
                </label>
              ))}
            </div>
            <div className="del-btn-row">
              <button className="btn-ghost" onClick={() => setStep(1)}>← Back</button>
              <button className="btn-solid-danger" onClick={() => setStep(3)} disabled={!reason}>Next Step</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="step-fade-in" key="s3">
            <p style={{fontSize:'.65rem',fontWeight:800,letterSpacing:'.1em',textTransform:'uppercase',color:'var(--text-2)',marginBottom:8,fontFamily:"'Space Mono',monospace"}}>Step 3 of 4</p>
            <div className="del-h2">Final confirmation</div>
            <div className="del-sub">Type <strong>DELETE</strong> in the box below to permanently remove your SequPay account and all associated data.</div>
            <input type="text" className="del-confirm-input" placeholder="Type DELETE here" value={confirmInput} onChange={e => setConfirmInput(e.target.value)} autoComplete="off" spellCheck="false" />
            <div className="del-btn-row">
              <button className="btn-ghost" onClick={() => setStep(2)}>← Back</button>
              <button className="btn-solid-danger" onClick={handleDelete} disabled={confirmInput !== 'DELETE' || isDeleting}>
                {isDeleting ? 'Processing…' : 'Delete Permanently'}
              </button>
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="step-fade-in" key="s4">
            <div className="del-success">
              <div className="s-emoji">✅</div>
              <h2>Request Submitted</h2>
              <p>Your account deletion request has been successfully submitted and assigned a ticket number.</p>
              <p>It may take up to <strong>30 days</strong> to fully process your request, remove all your personal data from our systems, and confirm via email.</p>
              <p style={{marginTop:12,fontSize:'.82rem',color:'var(--text-2)'}}>If you have any questions, email <a href="mailto:privacy@sequspace.com">privacy@sequspace.com</a></p>
              <button className="btn-primary-full" onClick={() => navigateTo('home')}>Return to Home</button>
            </div>
          </div>
        )}

        {step < 4 && (
          <button className="del-cancel-link" onClick={() => navigateTo('home')}>Cancel and return to home</button>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount;
